import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { BACKEND_DOMAIN } from "config";

const axiosInstance = axios.create({
  baseURL: BACKEND_DOMAIN,
  withCredentials: true,
});

axiosInstance.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};
  config.headers["X-Request-Id"] = uuidv4();
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && window.location.pathname !== "/login") {
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
